import { types } from "../../types/types";
import { AUTORIZACIONES_PRESUPUESTOS_ESTADOS } from "../../utils/constants";

const initialState = {
  activeStep: 0,
  afiliadoSeleccionado: null,
  bandejas: [],
  consumosAfiliado: [],
  documentacion: [],
  documentacionPractica: [],
  efectorDenunciaInternacion: [],
  empadronamientoSolicitud: [],
  estadoSolicitudes: null, //AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE?.toString(),
  estadoPresupuestos: AUTORIZACIONES_PRESUPUESTOS_ESTADOS.PENDIENTE?.toString(),
  localidades: [],
  notas: [],
  trackingNotas: [],
  nomencladorBandeja: [],
  observaciones: [],
  practicas: [],
  practicasPendientesDenuncia: [],
  presupuestos: [],
  presupuestosContadores: [],
  presupuestoSeleccionado: null,
  presupuestosTomados: [],
  presupuestosTomadosUsuario: [],
  recupero: [],
  recuperoSolicitud: [],
  sectoresInternacion: [],
  showForm: true,
  solicitudes: [],
  solicitudesContadores: [],
  solicitudesPendientes: [],
  solicitudSeleccionada: null,
  solicitudesTomadas: [],
  solicitudesTomadasUsuario: [],
  solicitudSeleccionadaSeguimiento: null,
  tiposDocumentacion: [],
  itemsTiposDocu: [],
  tiposDocumentacionPresupuesto: [],
  tiposDocumentacionPracticaSolicitud: [],
  tiposObservaciones: [],
  motivosCierreInterDom: [],
  tiposNotas: [],
  tiposSolicitudes: [],
  trackingRecupero: [],
  trackingSolicitud: [],
  trackingPresupuesto: [],
  trackingPracticasBandeja: [],
  afiliadosRecupero: [],
  solicitudesResult: null,
  contratoCreado: null,
  bandejasDeUsuario: [],
  solicitudesRelacionadas: [],
  motivosCierreOxigeno: [],
  solicitudesEnCarga: [],
  retomandoSolicAppMobile: false
};

export const AutorizacionesReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.autorizacionesClearReducer:
      return {
        ...initialState,
      };
    case types.autorizacionesSetRetomandoAppMobileTrue:
      return {
        ...state,
        retomandoSolicAppMobile: true
      };
    case types.autorizacionesSetRetomandoAppMobileFalse:
      return {
        ...state,
        retomandoSolicAppMobile: false
      };
    case types.autorizacionesClearSolicitudYPracticas:
      if (state.retomandoSolicAppMobile) {
        return state;
      } else {
        return {
          ...state,
          solicitudSeleccionada: null,
          practicas: [],
        };
      }
    case types.autorizacionesUpdateEstadoSolicitudes:
      return {
        ...state,
        estadoSolicitudes: action.payload,
      };
    case types.autorizacionesUpdateEstadoPresupuestos:
      return {
        ...state,
        estadoPresupuestos: action.payload,
      };
    case types.autorizacionesGetBandejasSuccess:
      return {
        ...state,
        bandejas: action.payload,
      };
    case types.autorizacionesGetBandejasError:
      return {
        ...state,
        bandejas: [],
      };
    case types.autorizacionesGetBandejasUsuarioSuccess:
      return {
        ...state,
        bandejasDeUsuario: action.payload,
      };
    case types.autorizacionesGetBandejasUsuarioError:
      return {
        ...state,
        bandejasDeUsuario: [],
      };
    case types.autorizacionesSetStep:
      return {
        ...state,
        activeStep: action.payload,
      };
    case types.autorizacionesSetCargarSolicitud:
      return {
        ...state,
        cargarSolicitud: action.payload,
      };
    case types.autorizacionesSetAfiliadoSeleccionado:
      return {
        ...state,
        afiliadoSeleccionado: action.payload,
      };
    case types.autorizacionesCleanAfiliadoSeleccionado:
      return {
        ...state,
        afiliadoSeleccionado: null,
      };
    case types.autorizacionesGetTiposSolicitudesSuccess:
      return {
        ...state,
        tiposSolicitudes: action.payload,
      };
    case types.autorizacionesGetTiposSolicitudesError:
      return {
        ...state,
        tiposSolicitudes: [],
      };
    case types.autorizacionesGetSolicitudesInternacionSuccess:
      return {
        ...state,
        solicitudes: action.payload,
      };
    case types.autorizacionesGetSolicitudesRelacionadasSuccess:
      return {
        ...state,
        solicitudesRelacionadas: action.payload,
      };
    case types.autorizacionesGetSolicitudesRelacionadasError:
      return {
        ...state,
        solicitudesRelacionadas: action.payload,
      };
    case types.autorizacionesGetSolicitudesSuccess:
      return {
        ...state,
        solicitudesResult: action.payload,
      };
    case types.autorizacionesGetSolicitudesEnCargaSuccess:
      return {
        ...state,
        solicitudesEnCarga: action.payload,
      };
    case types.autorizacionesGetSolicitudesEnCargaError:
      return {
        ...state,
        solicitudesEnCarga: [],
      };
    case types.autorizacionesGetSolicitudesSeguimientoSuccess:
      return {
        ...state,
        solicitudesResult: action.payload,
      };
    case types.autorizacionesCleanSolicitudes:
      return {
        ...state,
        solicitudes: [],
      };
    case types.autorizacionesGetSolicitudesError:
      return {
        ...state,
        solicitudes: [],
      };
    case types.autorizacionesGetContadoresSolicitudesSuccess:
      return {
        ...state,
        solicitudesContadores: action.payload,
      };
    case types.autorizacionesGetContadoresSolicitudesError:
      return {
        ...state,
        solicitudesContadores: [],
      };
    case types.autorizacionesGetSolicitudesPendientesSuccess:
      return {
        ...state,
        solicitudesPendientes: action.payload,
      };
    case types.autorizacionesCleanSolicitudesPendientes:
      return {
        ...state,
        solicitudesPendientes: [],
      };
    case types.autorizacionesGetSolicitudesPendientesError:
      return {
        ...state,
        solicitudesPendientes: [],
      };
    case types.autorizacionesSolicitudesMarcarTomada:
      return {
        ...state,
        solicitudes: state.solicitudes.map((item) =>
          item.idSolicitud === action.payload.solicitud.idSolicitud
            ? {
              ...item,
              solicitudesTomadas: [
                {
                  id: action.payload.id,
                  usuarioTomada: { userName: action.payload.auth.userName },
                  idUsuarioTomada: action.payload.auth.idUsuario,
                },
              ],
            }
            : item
        ),
      };
    case types.autorizacionesSolicitudesDesmarcarLiberada:
      return {
        ...state,
        solicitudes: state.solicitudes.map((item) =>
          item.idSolicitud === action.payload.idSolicitud
            ? {
              ...item,
              solicitudesTomadas: [],
            }
            : item
        ),
      };
    case types.autorizacionesPresupuestosMarcarTomada:
      return {
        ...state,
        presupuestos: state.presupuestos.map((item) =>
          item.idPresupuesto === action.payload.presupuesto.idPresupuesto
            ? {
              ...item,
              presupuestosTomados: [
                {
                  id: action.payload.id,
                  usuarioTomado: { userName: action.payload.auth.userName },
                  idUsuarioTomado: action.payload.auth.idUsuario,
                },
              ],
            }
            : item
        ),
      };
    case types.autorizacionesAddPractica:
      const practicasAux = Array.isArray(state.practicas)
        ? [...state.practicas]
        : [];
      return {
        ...state,
        practicas: [...practicasAux, action.payload],
      };
    case types.autorizacionesSetPeriodosPractica:
      return {
        ...state,
        practicas: state.practicas.map((item) =>
          item.idCodNom === action.payload.idCodNom
            ? {
              ...item,
              periodos: [...action.payload.items]
            }
            : item
        ),
      };
    case types.autorizacionesGetLocalidadesPorZonaSuccess:
      return {
        ...state,
        localidades: action.payload,
      };
    case types.autorizacionesGetLocalidadesPorZonaError:
      return {
        ...state,
        localidades: [],
      };
    case types.autorizacionesSetSolicitudSeleccionada:
      return {
        ...state,
        solicitudSeleccionada: action.payload,
      };
    case types.autorizacionesSetShowForm:
      return {
        ...state,
        showForm: action.payload,
      };
    case types.autorizacionesGetDocumentacionSuccess:
      return {
        ...state,
        documentacion: action.payload,
      };
    case types.autorizacionesGetDocumentacionError:
      return {
        ...state,
        documentacion: [],
      };
    case types.autorizacionesGetDocumentacionPracticaSuccess:
      return {
        ...state,
        documentacionPractica: action.payload,
      };
    case types.autorizacionesGetDocumentacionPracticaError:
      return {
        ...state,
        documentacionPractica: [],
      };
    case types.autorizacionesGetTiposDocumentacionSuccess:
      return {
        ...state,
        tiposDocumentacion: action.payload,
      };
    case types.autorizacionesAddTiposDocumentacion:
      return {
        ...state,
        tiposDocumentacion: [
          ...state.tiposDocumentacion,
          action.payload,
        ],
      };
    case types.autorizacionesSetTiposDocumentacion:
      return {
        ...state,
        tiposDocumentacion: state.tiposDocumentacion.map(
          item => item.idTipoDocSolicitud === action.payload.idTipoDocSolicitud ?
            {
              ...item,
              idTipoDoc: action.payload.idTipoDoc,
              obligatorio: action.payload.obligatorio,
              tipoDocumentacion: {
                idTipoDoc: action.payload.tipoDocumentacion.idTipoDoc,
                descripcion: action.payload.tipoDocumentacion.descripcion
              }
            }
            : item
        ),
      };
    case types.autorizacionesDeleteTiposDocumentacion:
      return {
        ...state,
        tiposDocumentacion: state.tiposDocumentacion.filter(item => item.idTipoDocSolicitud !== action.payload)
      };
    case types.autorizacionesGetTiposDocumentacionError:
      return {
        ...state,
        tiposDocumentacion: [],
      };

    case types.autorizacionesGetTiposDocuComboSuccess:
      return {
        ...state,
        loading: false,
        itemsTiposDocu: action.payload,
        cargada: true
      };
    case types.autorizacionesGetTiposDocuComboError:
      return {
        ...state,
        loading: false,
        error: action.payload,
        itemsTiposDocu: [],
        cargada: true
      };
    case types.autorizacionesGetTiposDocumentacionPresupuestoSuccess:
      return {
        ...state,
        tiposDocumentacionPresupuesto: action.payload,
      };
    case types.autorizacionesAddTiposDocumentacionPresupuesto:
      return {
        ...state,
        tiposDocumentacionPresupuesto: [
          ...state.tiposDocumentacionPresupuesto,
          action.payload,
        ],
      };
    case types.autorizacionesSetTiposDocumentacionPresupuesto:
      return {
        ...state,
        tiposDocumentacionPresupuesto: state.tiposDocumentacionPresupuesto.map(
          item => item.idTipoDocPresupuesto === action.payload.idTipoDocPresupuesto ?
            {
              ...item,
              idTipoDoc: action.payload.idTipoDoc,
              obligatorio: action.payload.obligatorio,
              tipoDocumentacion: {
                idTipoDoc: action.payload.tipoDocumentacion.idTipoDoc,
                descripcion: action.payload.tipoDocumentacion.descripcion
              }
            }
            : item
        ),
      };
    case types.autorizacionesDeleteTiposDocumentacionPresupuesto:
      return {
        ...state,
        tiposDocumentacionPresupuesto: state.tiposDocumentacionPresupuesto.filter(item => item.idTipoDocPresupuesto !== action.payload)
      };
    case types.autorizacionesGetTiposDocumentacionPresupuestoError:
      return {
        ...state,
        tiposDocumentacionPresupuesto: [],
      };
    case types.autorizacionesGetTiposDocumentacionPracticaSolicitudSuccess:
      return {
        ...state,
        tiposDocumentacionPracticaSolicitud: action.payload,
      };
    case types.autorizacionesAddTiposDocumentacionPracticaSolicitud:
      return {
        ...state,
        tiposDocumentacionPracticaSolicitud: [
          ...state.tiposDocumentacionPracticaSolicitud,
          action.payload,
        ],
      };
    case types.autorizacionesSetTiposDocumentacionPracticaSolicitud:
      return {
        ...state,
        tiposDocumentacionPracticaSolicitud: state.tiposDocumentacionPracticaSolicitud.map(
          item => item.idTipoDocPracticaSolicitud === action.payload.idTipoDocPracticaSolicitud ?
            {
              ...item,
              idTipoDoc: action.payload.idTipoDoc,
              obligatorio: action.payload.obligatorio,
              tipoDocumentacion: {
                idTipoDoc: action.payload.tipoDocumentacion.idTipoDoc,
                descripcion: action.payload.tipoDocumentacion.descripcion
              }
            }
            : item
        ),
      };
    case types.autorizacionesDeleteTiposDocumentacionPracticaSolicitud:
      return {
        ...state,
        tiposDocumentacionPracticaSolicitud: state.tiposDocumentacionPracticaSolicitud.filter(item => item.idTipoDocPracticaSolicitud !== action.payload)
      };
    case types.autorizacionesGetTiposDocumentacionPracticaSolicitudError:
      return {
        ...state,
        tiposDocumentacionPracticaSolicitud: [],
      };
    case types.autorizacionesGetTiposDocuSuccess:
      return {
        ...state,
        tiposDocumentacion: action.payload,
      };
    case types.autorizacionesAddTiposDocu:
      return {
        ...state,
        tiposDocumentacion: [
          ...state.tiposDocumentacion,
          action.payload,
        ],
      };
    case types.autorizacionesSetTiposDocu:
      return {
        ...state,
        tiposDocumentacion: state.tiposDocumentacion.map(item => item.idTipoDoc === action.payload.idTipoDoc
          ? { ...item, descripcion: action.payload.descripcion }
          : item
        ),
      };
    case types.autorizacionesDeleteTiposDocu:
      return {
        ...state,
        tiposDocumentacion: state.tiposDocumentacion.filter(item => item.idTipoDoc !== action.payload)
      };
    case types.autorizacionesGetTiposDocuError:
      return {
        ...state,
        tiposDocumentacion: [],
      };
    case types.autorizacionesSetPracticas:
      return {
        ...state,
        practicas: action.payload,
      };
    case types.autorizacionesSetPracticasPendientesDenuncia:
      return {
        ...state,
        practicasPendientesDenuncia: action.payload,
      };
    case types.autorizacionesGetPracticasSuccess:
      return {
        ...state,
        practicas: action.payload,
      };
    case types.autorizacionesGetPracticasError:
      return {
        ...state,
        practicas: [],
      };
    case types.autorizacionesUpdateSolicitudSeleccionada:
      return {
        ...state,
        solicitudSeleccionada: action.payload,
      };
    case types.autorizacionesGetTiposNotasSuccess:
      return {
        ...state,
        tiposNotas: action.payload,
      };
    case types.autorizacionesGetTiposNotasError:
      return {
        ...state,
        tiposNotas: [],
      };
    case types.autorizacionesGetNotasSuccess:
      return {
        ...state,
        notas: action.payload,
      };
    case types.autorizacionesGetTrackingNotasSuccess:
      return {
        ...state,
        trackingNotas: action.payload,
      };
    case types.autorizacionesGetTrackingNotasError:
      return {
        ...state,
        trackingNotas: [],
      };
    case types.autorizacionesGetNotasError:
      return {
        ...state,
        notas: [],
      };
    case types.autorizacionesGetTiposObservacionesSuccess:
      return {
        ...state,
        tiposObservaciones: action.payload,
      };
    case types.autorizacionesGetTiposObservacionesError:
      return {
        ...state,
        tiposObservaciones: [],
      };
    case types.autorizacionesGetObservacionesSuccess:
      return {
        ...state,
        observaciones: action.payload,
      };
    case types.autorizacionesGetObservacionesError:
      return {
        ...state,
        observaciones: [],
      };
    case types.autorizacionesGetMotivoCierreDenunciaInterDomSuccess:
      return {
        ...state,
        motivosCierreInterDom: action.payload,
      };
    case types.autorizacionesGetMotivoCierreDenunciaInterDomError:
      return {
        ...state,
        motivosCierreInterDom: [],
      };
    case types.autorizacionesGetTrackingSolicitudSuccess:
      return {
        ...state,
        trackingSolicitud: action.payload,
      };
    case types.autorizacionesGetTrackingSolicitudError:
      return {
        ...state,
        trackingSolicitud: [],
      };
    case types.autorizacionesGetTrackingPresupuestoSuccess:
      return {
        ...state,
        trackingPresupuesto: action.payload,
      };
    case types.autorizacionesGetTrackingPresupuestoError:
      return {
        ...state,
        trackingPresupuesto: [],
      };
    case types.autorizacionesGetNomencladorBandejaSuccess:
      return {
        ...state,
        nomencladorBandeja: action.payload,
      };
    case types.autorizacionesGetNomencladorBandejaError:
      return {
        ...state,
        nomencladorBandeja: [],
      };
    case types.autorizacionesGetSectoresInternacionSuccess:
      return {
        ...state,
        sectoresInternacion: action.payload,
      };
    case types.autorizacionesGetSectoresInternacionError:
      return {
        ...state,
        sectoresInternacion: [],
      };
    case types.autorizacionesUpdateNomencladorBandeja:
      return {
        ...state,
        nomencladorBandeja: action.payload,
      };
    case types.autorizacionesGetEfectorDenunciaInternacionSuccess:
      return {
        ...state,
        efectorDenunciaInternacion: action.payload,
      };
    case types.autorizacionesGetEfectorDenunciaInternacionError:
      return {
        ...state,
        efectorDenunciaInternacion: [],
      };
    case types.autorizacionesUpdateEfectorDenunciaInternacion:
      return {
        ...state,
        efectorDenunciaInternacion: state.efectorDenunciaInternacion.map(
          (item) =>
            item.idCartillaPrestador === action.payload.idCartillaPrestadores
              ? { ...item, auditoriaTerreno: action.payload.auditoriaTerreno }
              : item
        ),
      };
    case types.autorizacionesClearConsumosAfiliado:
      return {
        ...state,
        consumosAfiliado: [],
      };
    case types.autorizacionesGetConsumosAfiliadoSuccess:
      return {
        ...state,
        consumosAfiliado: action.payload,
      };
    case types.autorizacionesGetConsumosAfiliadoError:
      return {
        ...state,
        consumosAfiliado: [],
      };

    //PRESUPUESTOS
    case types.autorizacionesGetPresupuestosSuccess:
      return {
        ...state,
        presupuestos: action.payload,
      };
    case types.autorizacionesCleanPresupuestos:
      return {
        ...state,
        presupuestos: [],
      };
    case types.autorizacionesGetPresupuestosError:
      return {
        ...state,
        presupuestos: [],
      };
    case types.autorizacionesGetContadoresPresupuestosSuccess:
      return {
        ...state,
        presupuestosContadores: action.payload,
      };
    case types.autorizacionesGetContadoresPresupuestosError:
      return {
        ...state,
        presupuestosContadores: [],
      };
    case types.autorizacionesSetPresupustoSeleccionado:
      return {
        ...state,
        presupuestoSeleccionado: action.payload,
      };
    case types.autorizacionesUpdatePrespuestoSeleccionado:
      return {
        ...state,
        presupuestoSeleccionado: action.payload,
      };
    //SOLICITUDES TOMADAS
    case types.solicitudesTomadasUsuarioSuccess:
      return {
        ...state,
        solicitudesTomadasUsuario: action.payload,
      };
    case types.solicitudesTomadasUsuarioLiberar:
      return {
        ...state,
        solicitudesTomadasUsuario: state.solicitudesTomadasUsuario.filter(
          (item) => item.id !== action.payload
        ),
      };
    case types.solicitudesTomadasUsuarioAgregar:
      return {
        ...state,
        solicitudesTomadasUsuario: [
          ...state.solicitudesTomadasUsuario,
          action.payload,
        ],
      };
    case types.solicitudesTomadasUsuarioError:
      return {
        ...state,
        solicitudesTomadasUsuario: [],
      };
    case types.solicitudesTomadasSuccess:
      return {
        ...state,
        solicitudesTomadas: action.payload,
      };
    case types.solicitudesTomadasLiberar:
      return {
        ...state,
        solicitudesTomadas: state.solicitudesTomadas.filter(
          (item) => item.id !== action.payload
        ),
      };
    case types.solicitudesTomadasError:
      return {
        ...state,
        solicitudesTomadas: [],
      };
    case types.solicitudesTomadasLimpiar:
      return {
        ...state,
        solicitudesTomadas: [],
        solicitudesTomadasUsuario: [],
      };
    // PRESUPUESTOS TOMADOS
    case types.presupuestosTomadosUsuarioSuccess:
      return {
        ...state,
        presupuestosTomadosUsuario: action.payload,
      };
    case types.presupuestosTomadosUsuarioLiberar:
      return {
        ...state,
        presupuestosTomadosUsuario: state.presupuestosTomadosUsuario.filter(
          (item) => item.id !== action.payload
        ),
      };
    case types.presupuestosTomadosUsuarioAgregar:
      return {
        ...state,
        presupuestosTomadosUsuario: [
          ...state.presupuestosTomadosUsuario,
          action.payload,
        ],
      };
    case types.comprobantesTomadosLiberarTomadoPorIdPresupuesto:
      return {
        ...state,
        presupuestos: state.presupuestos.map((item) =>
          item.idPresupuesto === action.payload
            ? {
              ...item,
              presupuestosTomados: [],
            }
            : item
        ),
      };
    case types.presupuestosTomadosUsuarioError:
      return {
        ...state,
        presupuestosTomadosUsuario: [],
      };
    case types.presupuestosTomadosSuccess:
      return {
        ...state,
        presupuestosTomados: action.payload,
      };
    case types.presupuestosTomadosLiberar:
      return {
        ...state,
        presupuestosTomados: state.presupuestosTomados.filter(
          (item) => item.id !== action.payload
        ),
      };
    case types.presupuestosTomadosError:
      return {
        ...state,
        presupuestosTomados: [],
      };
    case types.presupuestosTomadosLimpiar:
      return {
        ...state,
        presupuestosTomados: [],
        presupuestosTomadosUsuario: [],
      };
    // SOLICITUDES SEGUIMIENTO
    case types.solicitudesSeguimientoSucces:
      return {
        ...state,
        solicitudSeleccionadaSeguimiento: action.payload,
      };
    case types.solicitudesSeguimientoAgregar:
      return {
        ...state,
        solicitudSeleccionadaSeguimiento: action.payload,
        solicitudes: state.solicitudes.map(
          (item) =>
            item.idSolicitud === action.payload.idSolicitud
              ? { ...item, seguimiento: { ...action.payload } }
              : item
        ),
      }
    case types.solicitudesSeguimientoDelete:
      return {
        ...state,
        solicitudSeleccionadaSeguimiento: null,
        solicitudes: state.solicitudes.map(
          (item) =>
            item.idSolicitud === action.payload
              ? { ...item, seguimiento: null }
              : item
        ),
      };
    case types.solicitudesSeguimientoError:
      return {
        ...state,
        solicitudSeleccionadaSeguimiento: null,
      };
    case types.autorizacionesGetDetalleSolicitudAuditoriaPorIdSolicitudSucces:
      return {
        ...state,
        solicitudes: state.solicitudes.map(
          (item) =>
            item.idSolicitud === action.payload.idSolicitud
              ? { ...action.payload }
              : item
        ),
        practicas: action.payload.practicas,
        solicitudSeleccionada: action.payload
      }
    case types.autorizacionesGetDetalleSolicitudPorIdSolicitudSucces:
      return {
        ...state,
        solicitudesResult: {
          ...state.solicitudesResult,
          results: state.solicitudesResult.results.map(
            (item) =>
              item.idSolicitud === action.payload.idSolicitud
                ? { ...action.payload }
                : item
          )
        },
        practicas: action.payload.practicas,
        solicitudSeleccionada: action.payload
      }
    case types.autorizacionesGetPracticasSolicitudSeleccionadaSuccess:
      return {
        ...state,
        solicitudSeleccionada: {
          ...state.solicitudSeleccionada, practicas: action.payload
        }
      }
    case types.autorizacionesGetPracticasPendientesDenunciaSolicitudSeleccionadaSuccess:
      return {
        ...state,
        solicitudSeleccionada: {
          ...state.solicitudSeleccionada, practicas: action.payload
        },
        practicasPendientesDenuncia: action.payload
      }
    case types.autorizacionesGetSolicitudPorIdSolicitudError:
      return {
        ...state,
        solicitudes: []
      }
    case types.abmRecuperoTraerSuccess:
      return {
        ...state,
        recupero: action.payload
      }
    case types.trackingRecuperoTraerSuccess:
      return {
        ...state,
        trackingRecupero: action.payload
      }
    case types.recuperoSolicitudTraerSuccess:
      return {
        ...state,
        recuperoSolicitud: action.payload
      }
    case types.autorizacionesEmpadronamientoSolicitud:
      return {
        ...state,
        empadronamientoSolicitud: action.payload
      }
    case types.autorizacionesGetContadoresSolicitudesClean:
      return {
        ...state,
        solicitudesContadores: [],
      };
    case types.autorizacionesGetContratoPresupuestoSuccess:
      return {
        ...state,
        contratoCreado: action.payload
      }
    case types.autorizacionesGetContratoPresupuestoError:
      return {
        ...state,
        contratoCreado: null
      }
    case types.autorizacionesGetMotivoCierreOxigenoSuccess:
      return {
        ...state,
        motivosCierreOxigeno: action.payload,
      };
    case types.autorizacionesGetMotivoCierreOxigenoError:
      return {
        ...state,
        motivosCierreOxigeno: [],
      };
    case types.seleccionSolicitudSeleccionadaBandejaSurge:
      return {
        ...state,
        // solicitudes: state.solicitudes.map(
        //   (item) =>
        //     item.idSolicitud === action.payload.idSolicitud
        //       ? { ...action.payload }
        //       : item
        // ),
        practicas: action.payload.practicas,
        solicitudSeleccionada: action.payload
      }
    case types.autorizacionesGetAfiliadoRecuperoSuccess:
      return {
        ...state,
        afiliadosRecupero: action.payload,
      };
    case types.autorizacionesGetSAfiliadoRecuperoError:
      return {
        ...state,
        afiliadosRecupero: [],
      };
    default:
      return state;
  }
};
